<template lang="pug">
  .yuxing
    .header
      img(src="@/assets/images/chongqing/yuxing-topImg.jpeg")
    .form
      el-form(label-width="5rem")
        el-form-item(label="姓名")
          el-input(type="text", placeholder="请输入真实姓名（已加密）", v-model="form.receiverName", @blur="handleNameChange")
        el-form-item(label="联系电话")
          el-input(type="text", placeholder="请输入联系电话（已加密）", v-model="form.receiverPhone")
        el-form-item(label="所在区县")
          #townSelector.mobile-select 请选择区县
        el-form-item(label="所在街道")
          #streetSelector.mobile-select 请选择街道
        el-form-item(label="收货地址")
          el-input(type="text", placeholder="小区/写字楼+门牌号", v-model="form.receiverAdd", @blur="isShowIDInfos = true")
        //- el-form-item(label="身份证姓名", v-show="isShowIDInfos")
        //-   el-input(type="text", placeholder="请输入身份证姓名", v-model="form.cardName")
        el-form-item(label="身份证号", v-show="isShowIDInfos")
          el-input(type="text", placeholder="请输入身份证号", v-model="form.cardNo")
      .tip * 请填写真实身份信息，未满16周岁/人证不一致/收货地址错误无法发货；
      .form-bottom
        el-button.btn-primary(@click="submit", v-if="!loading") 免费领取
        el-button.btn-primary(v-else, disabled, :loading="loading") 办理中...
        .protocol
          el-checkbox(v-model="agreeProtocol", label="我已阅读并同意")
          router-link(:to="{name: 'CQProtocol'}") 《入网协议》
    .package-info
      img(src="@/assets/images/chongqing/packageinfo.png")
    .app
      img(src="@/assets/images/chongqing/app.png")
    .notice
      img(src="@/assets/images/chongqing/title.png")
      img(src="@/assets/images/chongqing/notice.png")
    .pop-cover(v-if='selectTelNumber')
    .pop-container(v-if='selectTelNumber')
      .pop-title
        el-row
          el-col(:span='4')
            .close-pop(@click='selectTelNumber = false')
              i.el-icon-close
          el-col(:span='16')
            span 选择号码列表
      .pop-content(v-if='selectTelNumber')
        el-row
          el-col(:span='24')
            el-input(placeholder='输入号段（例如：135、158、187）点击查询', v-model='searchNumber.number')
              i.el-input__icon.el-icon-search(slot='suffix', @click='getTelList(1)')
        el-row
          el-col.telnumber-item(:span='12', v-for='item in mobilePool', :key='item.number')
            div(@click='chooseTelNumber(item)')
              span {{item.number}}
      .select-telnumber-footer(v-if='selectTelNumber')
        el-row
          el-col(:span='24')
            div(@click='turnPagePhoneList')
              i.el-icon-refresh
              | 换一批
</template>

<script>
import MobileSelect from 'mobile-select'
// eslint-disable-next-line
const ID_REGEX = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/
export default {
  name: 'CQYuxing',
  data() {
    return {
      carrierId: 15,
      isShowIDInfos: false,
      form: {
        channel: 'TUIA',
        receiverProvinceCode: '500000',
        receiverProvinceName: '重庆',
        receiverTownName: '',
        receiverTownCode: '',
        receiverStreetName: '',
        receiverStreetCode: '',
        receiverCityName: '重庆',
        receiverCityCode: '4',
        cardName: '',
        cardNo: '',
        mobile: '',
        packageId: 567, // 移动渝星卡19元档
        receiverName: '',
        receiverPhone: '',
        receiverAdd: '',
        transactionId: null
      },
      agreeProtocol: true,
      provincePool: [],
      cityPool: [],
      citySelector: null,
      townPool: [],
      townSelector: null,
      streetPool: [],
      streetSelector: null,
      mobilePool: [],
      selectTelNumber:false,//选择号码页面
      totalPhonePage: false,
      //搜索号码关键词
      searchNumber: {
        number: '',
        pageNumber: 1,
        pageSize: 12
      },
      loading: false
    }
  },
  mounted() {
    this.initTownSelector()
    this.randomSelectMobile()
  },
  methods: {
    submit() {
      if(!this.agreeProtocol) {
        this.$message.warning('请阅读并同意《入网协议》')
        return
      }
      this.occupationTelphone()
    },
    handleSelectedArea(area) {
      this.form.area = area.province.value + area.city.value + area.area.value
      this.isShowAreaSelector = false
    },
    handleNameChange() {
      if (!this.form.cardName) {
        this.form.cardName = this.form.receiverName
      }
    },
    chooseTelNumber (item) {
      this.form.mobile = item.number;
      this.selectTelNumber = false;
    },
    randomSelectMobile (){
      this.searchNumber={
        number:'',
        pageNumber:1,
        pageSize:12
      };
      this.tellist = [];
      this.getTelList()
    },
    openSelectTelNumber (){
      this.searchNumber={
        number:'',
        pageNumber:1,
        pageSize:12
      };
      this.tellist = [];
      this.selectTelNumber = true;
      this.getTelList()
    },
    turnPagePhoneList(){
      if(this.searchNumber.pageNumber >= 1
        && this.searchNumber.pageNumber <= this.totalPhonePage) {
        if(this.searchNumber.pageNumber < this.totalPhonePage) {
          this.searchNumber.pageNumber += 1;
        } else if (this.searchNumber.pageNumber == this.totalPhonePage){
          this.searchNumber.pageNumber = 1;
        }
        this.getTelList();
      }
    },
    getTelList(pageNumber){
      this.loading = true;
      this.searchNumber.pageNumber = pageNumber || this.searchNumber.pageNumber
      this.$http({
        url: '/shop/common/getNumberPool',
        params: {
          page:this.searchNumber.pageNumber,
          limit:this.searchNumber.pageSize,
          numberStart: this.searchNumber.number,
          carrierId: this.carrierId
        },
        withCredentials: true
      }).then(res => {
          if(res.data.success) {
            this.mobilePool = res.data.sub_data.records;
            this.totalPhonePage = res.data.sub_data.pages;
            // random mobile
            this.form.mobile = this.mobilePool[Math.floor(Math.random() * this.mobilePool.length)].number
          }else{
            this.$message.warning('无可用号码，请重新输入')
          }     
      }).catch(() => {
        this.$message.error('请求失败！');
      }).finally(() => {
        this.loading = false;
      })
    },
    initProvinceSelector() {
      this.$http({
        url: '/shop/common/getCarrierArea',
        params: {
          areaCode: null,
          level: null,
          carrierId: this.carrierId
        },
        withCredentials: true,
      }).then(res => {
        if (res.data.success) {
          res.data.sub_data.forEach(p => {
            let _p = {
              id: p.province_code,
              value: p.province_name,
              childs: []
            }
            this.provincePool.push(_p)
          })
          new MobileSelect({
            trigger: "#provinceSelector",
            title: "省",
            wheels: [
              {data: this.provincePool}
            ],
            callback: (indexArr, data) => {
              if (data){
                if(data.length >= 1){
                  this.form.receiverProvinceCode = data[0].id
                  this.form.receiverProvinceName = data[0].value
                  this.initCitySelector()
                }
              } else {
                this.form.receiverProvinceCode = ''
                this.form.receiverProvinceName = ''
                this.form.receiverCityName = ''
                this.form.receiverCityCode = ''
              }
            }
          })
        }
      })
    },
    initCitySelector() {
      this.$http({
        url: '/shop/common/getCarrierArea',
        params: {
          areaCode: this.form.receiverProvinceCode,
          level: 1,
          carrierId: this.carrierId
        },
        withCredentials: true,
      }).then(res => {
        if (res.data.success) {
          let _city_pool = res.data.sub_data
          this.cityPool = []
          _city_pool.forEach(c => {
            let _c = {
              id: c.city_code,
              value: c.city_name,
              childs: []
            }
            this.cityPool.push(_c)
          })
          if (!this.citySelector) {
            this.citySelector = new MobileSelect({
              trigger: "#citySelector",
              title: "所在城市",
              wheels: [
                {data: this.cityPool}
              ],
              callback:(indexArr, data) => {
                if(data){
                  if(data.length >= 1){
                    this.form.receiverCityCode = data[0].id
                    this.form.receiverCityName = data[0].value
                    this.initTownSelector()
                  }
                }else{
                  this.form.receiverTownName = ''
                  this.form.receiverTownCode = ''
                  this.form.receiverCityName = ''
                  this.form.receiverCityCode = ''
                }
              }
            })
          } else {
            this.citySelector.updateWheel(0, this.cityPool)
            this.citySelector.locatePosition(0, 0)
          }
        }
      })
    },
    initTownSelector() {
      this.$http({
        url: '/shop/common/getCarrierArea',
        params: {
          areaCode: this.form.receiverCityCode,
          level: 2,
          carrierId: this.carrierId
        },
        withCredentials: true,
      }).then(res => {
        if (res.data.success) {
          let _town_pool = res.data.sub_data
          this.townPool = []
          _town_pool.forEach(c => {
            let _c = {
              id: c.area_code,
              value: c.area_name,
              childs: []
            }
            this.townPool.push(_c)
          })
          if (!this.townSelector) {
            this.townSelector = new MobileSelect({
              trigger: "#townSelector",
              title: "所在区/县",
              wheels: [
                {data: this.townPool}
              ],
              callback:(indexArr, data) => {
                if(data){
                  if(data.length >= 1){
                    this.form.receiverTownCode = data[0].id
                    this.form.receiverTownName = data[0].value
                    this.initSteetSelector()
                  }
                }else{
                  this.form.receiverTownName = ''
                  this.form.receiverTownCode = ''
                  this.form.receiverStreetName = ''
                  this.form.receiverStreetCode = ''
                }
              }
            })
          } else {
            this.townSelector.updateWheel(0, this.townPool)
            this.townSelector.locatePosition(0, 0)
          }
        }
      })
    },
    initSteetSelector() {
      this.$http({
        url: '/shop/common/getCarrierArea',
        params: {
          areaCode: this.form.receiverTownCode,
          level: 3,
          carrierId: this.carrierId
        },
        withCredentials: true,
      }).then(res => {
        if (res.data.success) {
          let _street_pool = res.data.sub_data
          this.streetPool = []
          _street_pool.forEach(c => {
            let _c = {
              id: c.street_code,
              value: c.street_name,
              childs: []
            }
            this.streetPool.push(_c)
          })
          if (!this.streetSelector) {
            this.streetSelector = new MobileSelect({
              trigger: "#streetSelector",
              title: "所在街道",
              wheels: [
                {data: this.streetPool}
              ],
              callback:(indexArr, data) => {
                if(data){
                  if(data.length >= 1){
                    this.form.receiverStreetCode = data[0].id
                    this.form.receiverStreetName = data[0].value
                  }
                }else{
                  this.form.receiverStreetName = ''
                  this.form.receiverStreetCode = ''
                }
              }
            })
          } else {
            this.streetSelector.updateWheel(0, this.streetPool)
            this.streetSelector.locatePosition(0, 0)
          }
        }
      })
    },
    /**
     * 验证表单，重庆不需要占号
     */
    occupationTelphone () {
      if(!this.form.cardName){
        this.$message.warning('请先输入身份证姓名')
        return;
      }
      if(!this.form.cardNo){
        this.$message.warning('请先输入身份证号')
        return;
      }
      if(!this.form.mobile){
        this.$message.warning('请先选择入网手机号')
        return false;
      }
      if(!ID_REGEX.test(this.form.cardNo)) {
        this.$message.warning('请输入正确的身份证号')
        return;
      }
      if(!this.form.receiverProvinceCode){
        this.$message.warning('请选择收货省份')
        return;
      }
      if(!(this.form.receiverCityCode && this.form.receiverTownCode)){
        this.$message.warning('请选择收货市/区县')
        return;
      }
      if(!this.form.receiverStreetCode){
        this.$message.warning('请选择收所在街道')
        return;
      }
      if(!this.form.receiverAdd){
        this.$message.warning('请输入收货地址')
        return;
      }
      this.checkPurchaseQualification();
    },
    /**
     * 一证五卡
     */
    checkPurchaseQualification(){
      var formdata = new FormData()
      formdata.append('cardName', this.form.cardName)
      formdata.append('cardNo', this.form.cardNo)
      formdata.append('mobile', this.form.mobile)
      this.loading = true;
      this.$http({
        method: 'POST',
        headers: {'Content-Type': 'multipart/form-data'},
        withCredentials: true,
        url: '/shop/cqyd/card/checkIdNum',
        data: formdata
      }).then(res => { 
        if(res.data.success){
          this.handleSubmit()
        }else{
          this.$message.warning(res.data.message)
        }      
      }).catch(() => {
        this.$message.error('请求失败！')
      }).finally(() => {
        this.loading = false;
      }) 
    },
    /**
     * 重庆本地无需上传身份证，直接办理
     */
    handleSubmit(){
      this.loading = true;
      var formdata = new FormData()
      formdata.append('channel', this.form.channel)
      formdata.append('cardName', this.form.receiverName) // 与联系人一致
      formdata.append('cardNo', this.form.cardNo)
      formdata.append('mobile', this.form.mobile)
      formdata.append('packageId', this.form.packageId)
      formdata.append('carrierId', this.carrierId)
      formdata.append('receiverName',this.form.receiverName)//联系人
      formdata.append('receiverPhone',this.form.receiverPhone)//联系电话
      formdata.append('receiverProvinceName', this.form.receiverProvinceName)//省
      formdata.append('receiverCityName', this.form.receiverCityName)//市
      formdata.append('receiverTownName', this.form.receiverTownName)//区、县
      formdata.append('receiverProvinceCode', this.form.receiverProvinceCode)//省
      formdata.append('receiverCityCode', this.form.receiverCityCode)//市
      formdata.append('receiverTownCode', this.form.receiverTownCode)//区、县
      formdata.append('receiverStreetCode', this.form.receiverStreetCode)//街道
      formdata.append('receiverStreetName', this.form.receiverStreetName)//街道
      formdata.append('receiverAdd', this.form.receiverAdd)//地址
      this.$http({
        method: 'post',
				headers: {'Content-Type': 'multipart/form-data'},
				withCredentials: true,
				url: '/shop/cqyd/card/createCardOrderOAO',
				data: formdata
      }).then(res => { 
        if (res.data.success || res.data.result_code == '0') {
          if (window.countLog) {
            window.countLog.ready(function() {
              window.countLog.init(function() { 
              }, {
                isCopy: 0, 
                pageType: 0 
              })
            })
          }
          this.$message.success('下单成功！')
          this.$router.push({
            name: 'CQYuxingSuccess'
          })
				} else {
					this.$message.warning('下单失败，' + res.data.message)
				}   
      }).catch(() => {
        this.$message.error('请求失败！')
      }).finally(() => {
        this.loading = false
      });
    }
  }
}
</script>
<style lang="less" scope>
.yuxing{
  background-color: #fff;
}
.header{
  img{
    width: 100%;
  }
}
.form{
  width: 75%;
  margin: 0 auto;
  background-color: #135AA6;
  padding: 1rem 1.5rem;
  color: #fff;
  .el-form-item{
    margin-bottom: .4rem;
  }
  .el-form-item__label{
    height: 2rem;
    line-height: 2rem;
    padding: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #e5f2ff;
  }
  .el-form-item__content{
    line-height: 2rem;
  }
  .el-input__inner{
    height: 2rem;
  }
  .el-input__inner, .el-textarea__inner{
    line-height: 2rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
    padding: 0 .8rem;
    border: 0;
    background-color: #e5f2ff;
  }
  .el-textarea__inner{
    border-bottom-left-radius: 4px;
  }
  .tip{
    font-size: .8rem;
  }
  .form-bottom{
    .btn-primary{
      width: 100%;
      margin: 1rem 0;
      background-color: rgb(241, 167, 48);
      color: #fff;
      border: 0;
    }
    text-align: center;
    .el-checkbox__label{
      font-size: .8rem;
      color: #fff;
    }
    a{
      font-size: .8rem;
      color: #fff;
    }
  }
}
.app, .package-info{
  margin: 0 auto;
  width: 99%;
  img{
    width: 100%;
  }
  margin-top: 2rem;
}
.app{
  margin-top: 0;
}
.notice{
  margin: 0 auto;
  margin-top: 1rem;
  width: 90%;
  img{
    width: 100%;
  }
  margin-bottom: 6rem;
}
.mobile-select{
  background-color: #e5f2ff;
  color: #606266;
  padding: 0 .8rem;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.pop-cover{
  width: 100%;
  height: 100vh;
  background-color: #000000;
  opacity: .5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
}
.pop-container{
  width: 96%;
  position: fixed;
  left:2%;
  top:15%;
  background-color: #ffffff;
  z-index: 3;
  border-radius: 10px;
}
.package-pop{
  top:10vh;
}
.pop-title{
  font-size: 1.125rem;
  height: 3rem;
  line-height: 3rem;
  text-align: center;
  border-bottom: 1px solid #EDEDED;    
  background: white;
  color:#666;
  border-radius:10px 10px 0 0;
}
.close-pop{
  padding: 0 1rem;
}
.pop-content{        
  font-size: .875rem;
  padding:5px;
}
.package-pop .pop-content{
  max-height: 70vh;
  overflow-y: auto;
  padding: .75rem .75rem 1rem .75rem;
}
.pop-content{
  .el-input__icon.el-icon-search{
    width: 38px;
    font-size: 26px;
    color: #606266;
    font-weight: bold;
  }
  img{
    width: 100%;
    max-width: 100%;
  }
}
.select-telnumber-footer{
  color: #0084cf;
  height: 3rem;
  line-height: 3rem;
  text-align: center;
  border-top: 1px solid #DEDEDE;   
  border-radius:0 0 10px 10px ;
  i{
    margin-right: 0.5rem;
  }
}
.select-package{
  font-size: 1.125rem;
  color: #fff;
  background: #0084cf;
}
.telnumber-item{
    text-align: center;
    line-height:2.5rem;
    font-size: 1rem;
    font-weight: bold;
}
.el-tooltip__popper{
    max-width: 60%;
    margin:0 10%
}
</style>